import { render, staticRenderFns } from "./AttributesPage.vue?vue&type=template&id=a2064ad2&scoped=true"
import script from "./AttributesPage.vue?vue&type=script&lang=js"
export * from "./AttributesPage.vue?vue&type=script&lang=js"
import style0 from "./AttributesPage.vue?vue&type=style&index=0&id=a2064ad2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2064ad2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2064ad2')) {
      api.createRecord('a2064ad2', component.options)
    } else {
      api.reload('a2064ad2', component.options)
    }
    module.hot.accept("./AttributesPage.vue?vue&type=template&id=a2064ad2&scoped=true", function () {
      api.rerender('a2064ad2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/use-metrics/pages/AttributesPage.vue"
export default component.exports